import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../../components/button';
import styles from './report.module.scss';

const Report = ({ airport }) => {
  const history = useHistory();
  const handleReview = () => {
    history.push(`/conditions/${airport.code}`);
  };
  return (
    <div className={styles.report}>
      <div className={styles.title}>Airfield Conditions Report</div>
      <span className={styles.review}><Button onClick={handleReview} translationID="review" defaultText="Review" /></span>
    </div>
  );
};

export default Report;
